/**
 * The drawn Diwa sigil — seven gold companion stars around the crimson ego, as
 * inline SVG. This REPLACES every rendering of the diwa-logo.png bitmap on the
 * public surfaces (the PNG bakes in a dark square that reads as a dead pixel on
 * any ground that isn't the void — a named critique fix). Scales crisply at any
 * size and re-tints per theme via currentColor-free explicit hues.
 */

export function DiwaSigil({ size = 22, className }: { size?: number; className?: string }) {
  return (
    <svg
      viewBox="0 0 120 100"
      width={size}
      height={Math.round(size * (100 / 120))}
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <g fill="var(--dwl-sigil-gold, #c9a96e)">
        <circle cx="60" cy="34" r="4" />
        <circle cx="38" cy="26" r="5" />
        <circle cx="82" cy="26" r="5" />
        <circle cx="29" cy="42" r="4" />
        <circle cx="91" cy="42" r="4" />
        <circle cx="41" cy="64" r="4.5" />
        <circle cx="79" cy="64" r="4.5" />
      </g>
      <circle cx="60" cy="50" r="6" fill="var(--dwl-sigil-ember, #c0392b)" />
    </svg>
  )
}
